<template>

    <div id="homeBox">
        <div class="flexcenter" id="flexcenter">
            <el-button type="text" style="height: 2.5rem"  icon="el-icon-plus"  @click="add">新增设备</el-button>

            <div style="margin-right: 20px">
                <el-input


                        size="mini"
                        style="width: 200px  "

                        placeholder="请输入搜索内容"
                        v-model="Searchdata"
                        clearable>
                </el-input>
                <el-button  class="mrl15 " icon="el-icon-search" circle  @click="Searchrevise" size="mini"></el-button>
            </div>
        </div>
        <el-table
                id="eltable"
                ref="deliverlight"
                :height="tableHeight"
                highlight-current-row
                size="mini"
                :data="tableData"
                style="width: 100%"
                row-key="id"
                stripe
                border
                :header-cell-style="{background:'#eef1f6',color:'black',}"
                :header-row-style="{height:'50px'}"





                :highlight-current-row="true"
                @expand-change="dddd"
        >
            <el-table-column type="expand"  ref="tree">
                <template slot-scope="scope" width="1">
                    <el-table

                            ref="table"
                            size="mini"
                            border
                            :data="scope.row.erbei"
                            :header-cell-style="{background:'#F0FFFF',color:'#000',}"


                       >

                        <el-table-column
                                label="dcs编号"
                                align="center"

                                prop="no" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column

                                label="数据类型"
                                width="90"
                                show-overflow-tooltip
                        >
                            <template slot-scope="scope" >
                                <div >
                                    <span v-if="scope.row.type==0">无</span>

                                    <span v-if="scope.row.type==1">温度</span>
                                    <span v-if="scope.row.type==2">压力</span>
                                    <span v-if="scope.row.type==3">液位</span>
                                    <span v-if="scope.row.type==4">瞬时流量</span>
                                    <span v-if="scope.row.type==5">累计流量</span>
                                    <span v-if="scope.row.type==6">耗电量</span>
                                    <span v-if="scope.row.type==7">用汽量</span>
<!--                                    <span v-if="scope.row.type==8">流量计</span>-->
<!--                                    <span v-if="scope.row.type==9">重量</span>-->
<!--                                    <span v-if="scope.row.type==10">称重</span>-->
<!--                                    <span v-if="scope.row.type==11">流量计</span>-->
                                </div>

                            </template>
                        </el-table-column>
                        <el-table-column
                                label="dcs名称"
                                align="center"
                                prop="name" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                align="center"
                                label="控件标题"

                                prop="inputTitle" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                align="center"
                                label="控件类型"

                                prop="inputType" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                align="center"
                                label="控件单位"
                                width="80"
                                prop="inputUnit" show-overflow-tooltip>
                            <template slot-scope="scope" >
                                <div >
                                    <span v-if="scope.row.inputUnit!==''">{{scope.row.inputUnit}}</span>
                                    <span v-if="scope.row.inputUnit==''">无</span>


                                </div>

                            </template>
                        </el-table-column>
                        <el-table-column
                                align="center"
                                label="上限"

                                prop="upperBound" show-overflow-tooltip>
                            <template slot-scope="scope" >
                                <div >
                                    <span v-if="scope.row.upperBound!==''">{{scope.row.upperBound}}{{scope.row.inputUnit}}</span>
                                    <span v-if="scope.row.upperBound==''">无</span>


                                </div>

                            </template>
                        </el-table-column>
                        <el-table-column
                                align="center"
                                label="下限"
                                prop="lowerBound" show-overflow-tooltip>
                            <template slot-scope="scope" >
                                <div >
                                    <span v-if="scope.row.lowerBound!==''">{{scope.row.lowerBound}}{{scope.row.inputUnit}}</span>
                                    <span v-if="scope.row.lowerBound==''">无</span>


                                </div>

                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="orderNo"
                                label="排序"
                                width="50"
                                show-overflow-tooltip
                        >
                        </el-table-column>
                        <!--                        <template  slot-scope="scope">-->


                        <!--                        </template>-->
                        <el-table-column
                                width="130"
                                label="操作">
                            <template slot-scope="scope" >
                                <div >
                                    <el-button  type="text" size="mini" @click="editson(scope.row)">编辑</el-button>
                                    <el-button style="color:red;" type="text" size="mini" @click="delson(scope.row)">删除</el-button>


                                </div>

                            </template>
                        </el-table-column>

                    </el-table>
                </template>

            </el-table-column>
            <el-table-column
                    prop="no"
                    label="设备编号"
                    width="180"
            show-overflow-tooltip>
            </el-table-column>

            <el-table-column
                    prop="name"
                    label="设备名"
                    width="90"
                    show-overflow-tooltip
                    >
            </el-table-column>

            <el-table-column
                    prop="nfc"
                    label="nfc编码"
                    width="70"
                    show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                    prop="dcsNo"
                    label="dcs编码"
                    width="90"
                    show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column

                    label="设备类型"
                    width="80"
                    show-overflow-tooltip
            >
                <template slot-scope="scope" >
                    <div >
                        <span v-if="scope.row.type==0">无</span>

                        <span v-if="scope.row.type==1">水表</span>
                        <span v-if="scope.row.type==2">电表</span>
                        <span v-if="scope.row.type==3">汽表</span>
                        <span v-if="scope.row.type==4">气表</span>
                        <span v-if="scope.row.type==5">压力表</span>
                        <span v-if="scope.row.type==6">温度表</span>
                        <span v-if="scope.row.type==7">液位计</span>
                        <span v-if="scope.row.type==8">PH</span>
                        <span v-if="scope.row.type==9">直罐</span>
                        <span v-if="scope.row.type==10">卧罐</span>
                        <span v-if="scope.row.type==11">球罐</span>
                        <span v-if="scope.row.type==12">流量计</span>
                        <span v-if="scope.row.type==13">精馏塔</span>
                        <span v-if="scope.row.type==14">立式</span>
                        <span v-if="scope.row.type==15">立式反应器</span>



                    </div>

                </template>
            </el-table-column>

            <el-table-column
                    prop="position"
                    label="设备位置"
                    width="120"
                    show-overflow-tooltip
            >
            </el-table-column>

            <el-table-column
                    prop="orderNo"
                    label="排序"
                    width="50"
                    show-overflow-tooltip
            >
            </el-table-column>

            <el-table-column
                    prop="description"
                    label="描述"
            show-overflow-tooltip>
            </el-table-column>

            <el-table-column
width="70"
                    label="状态"
                    show-overflow-tooltip
            >
                <template slot-scope="scope" >
                    <div >
                        <span v-if="scope.row.state==1">运行中</span>
                        <span v-if="scope.row.state==2">调整中</span>
                        <span v-if="scope.row.state==3">停机</span>
                    </div>

                </template>
            </el-table-column>

                <el-table-column
                        width="70"
                        prop="vc_lruname"
                        label="录入人"
                show-overflow-tooltip>
                </el-table-column>

                <el-table-column
                        prop="createTime"
                        width="90"
                        label="录入时间"
                show-overflow-tooltip>
<!--                    <template slot-scope="scope" >-->
<!--                       <span>{{scope.row.createTime.substring(0,10)}}</span>-->

<!--                    </template>-->
                </el-table-column>
            <el-table-column
                    width="170"
                    label="操作">
                <template slot-scope="scope" >
                    <div >
                        <el-button  type="text" size="mini" @click="edit(scope.row)">编辑</el-button>
                        <el-button  style="color:red;"  type="text" size="mini" @click="del(scope.row)">{{$t('button_nullify')}}</el-button>
                        <el-button    type="text" size="mini" @click="addson(scope.row)">新增DCS</el-button>
<!--                        <el-button v-if="scope.row.dcsNum!==0"   type="text" size="mini" @click="seedetail(scope.row)">{{scope.row.see==1?'收起':'查看'}}</el-button>-->

                    </div>

                </template>
            </el-table-column>
        </el-table>
        <!--        分页器-->
        <div class="block">
            <div class="pages">
                <div class="choosepage flexother  fl">
                    <el-pagination
                            small
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :page-sizes="[10, 20, 30, 40]"

                            :page-size="this.pageSize"
                            layout="total,sizes"
                            :total="this.total"
                    >
                    </el-pagination>
                    <el-pagination
                            small
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :pager-count="5"
                            :page-size="this.pageSize"
                            layout="prev, pager, next, jumper"
                            :total="this.total">

                    </el-pagination>
                </div>

            </div>
        </div>
        <el-dialog
            :close-on-click-modal="false"
            style="display: flex;justify-content: center;align-items: center;color: black;font-weight: bold"
            top="350px"
            width="31.429rem"
            height="300"
            :title="title"
            :visible.sync="bianjipingtai"
            v-if="bianjipingtai"


    >
        <adddcs :listid="listid" @clist="clist" @list="list" @dcslist="dcslist" :editData="editData" @close="close"></adddcs>
    </el-dialog>
        <el-dialog
                :close-on-click-modal="false"
                style="display: flex;justify-content: center;align-items: center;color: black;font-weight: bold"
                top="100px"
                width="500px"
                height="300"
                :title="title"
                :visible.sync="sondialog"
                v-if="sondialog"


        >
            <addson  @list="list" :editData="editData" @close="close"></addson>
        </el-dialog>
        <el-dialog
                :close-on-click-modal="false"
                style="display: flex;justify-content: center;align-items: center;color: black;font-weight: bold"
                title="提示"
                :visible.sync="delDialogVisible"
                width="400px"
                top="30px"
                height="300"
                center
                v-if="delDialogVisible"
        >
            <div style="display:flex;justify-content: center;align-items: center;margin: 15px 0">{{deldetail}}</div>
            <span slot="footer" class="dialog-footer">
    <el-button @click="delDialogVisible = false">{{$t('button_cancel')}}</el-button>
    <el-button type="primary" @click="submitdel">确 定</el-button>
  </span>
        </el-dialog>
        <el-dialog
                :close-on-click-modal="false"
                style="display: flex;justify-content: center;align-items: center;color: black;font-weight: bold"
                title="提示"
                :visible.sync="delsonDialogVisible"
                width="400px"
                top="30px"
                height="300"
                center
                v-if="delsonDialogVisible"
        >
            <div style="display:flex;justify-content: center;align-items: center;margin: 15px 0">{{deldetail}}</div>
            <span slot="footer" class="dialog-footer">
    <el-button @click="delsonDialogVisible = false">{{$t('button_cancel')}}</el-button>
    <el-button type="primary" @click="submitsondel">确 定</el-button>
  </span>
        </el-dialog>
    </div>
</template>

<script>
    import {baseerp} from "@/utils/baseUrl";
    import * as API from "./api";
    import {mapActions} from "vuex";
    import adddcs from "./component/AddDcs";
    import addson from "./component/AddSon";

    export default{
        name:'DcsDetail',
        components:{
            adddcs,
            addson
        },

        data(){
            return{
                delsonDialogVisible:false,
                sondialog:false,
                see:false,
                maps:new Map(),
                childrenlist:[],
                loading:'',
                sbtype:[{
                    id:1,
                    v:'水表'
                },{
                    id:2,
                    v:'电表'
                },{
                    id:3,
                    v:'汽表'
                },{
                    id:4,
                    v:'气表'
                },{
                    id:5,
                    v:'压力表'
                },{
                    id:6,
                    v:'温度表'
                },{
                    id:7,
                    v:'液位计'
                },{
                    id:8,
                    v:'PH'
                },{
                    id:9,
                    v:'直罐'
                },{
                    id:10,
                    v:'卧罐'
                },
                    {
                        id:11,
                        v:'球罐'
                    },{
                    id:12,
                    v:'流量计'
                }],
                editData:{},
                bianjipingtai:false,//编辑弹框
                Searchdata:'',//搜索内容
                currentPage:1,
                pageSize:10,
                deldetail:'',
                total:0,
                listid:0,
                baseerp:'',
                tableData: [],
                tableHeight:0,//列表高度
                consumername:[],//消费名字数据
                title:'',
                delDialogVisible:false//删除弹框
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);

                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },

        mounted(){
            this.$nextTick(()=>{
                this.onResize();

            })
            // this.$refs.deliverlight.toggleRowExpansion(item,false)
            //公共样式
            this.baseerp=baseerp
            this.dcslist()
            // this.$nextTick(function () {
            //     this.heightAuto();
            // window.addEventListener('resize',this.onResize);

            // });

        },

        beforeDestroy() {
            // window.removeEventListener('resize',this.heightAuto)
        },
        methods:{
            clist(){
                this.tableData.forEach(item=>{
                    this.$refs.deliverlight.toggleRowExpansion(item,false)

                })
                // this.$refs.deliverlight.toggleRowExpansion(item,false)

            },
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-80

                // console.log(this.tableHeight)
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },
            ...mapActions(["getCurrentMenuId"]),
            //高度

            heightAuto(){
                // this.$nextTick(()=>{
                //     document.getElementById('body').getBoundingClientRect().top
                // })
                this.tableHeight = window.innerHeight - document.getElementById('body').getBoundingClientRect().top -48 -36    ;

                // console.log(this.tableHeight)
                // console.log(document.getElementById('body').getBoundingClientRect().top)
                // console.log(window.innerHeight)
                // console.log()
            },


            //关闭弹框
            close(){
                this.sondialog=false
                this.bianjipingtai=false
            },
            //页面搜索
            Searchrevise(){
                this.dcslist()
                this.tableData.forEach(item=>{
                    // item
                    this.$refs.deliverlight.toggleRowExpansion(item,false)

                })
                // this.$refs.tree.root.expanded = false;
                this.currentPage=1
            },
            //分页
            handleSizeChange(val) {
                // console.log(`每页 ${val} 条`);
                this.pageSize = val;    //动态改变
                this.clist()
                this.dcslist()
            },
            handleCurrentChange(val) {
                // console.log(`当前页: ${val}`);
                this.currentPage = val;    //动态改变
                this.clist()

                this.dcslist()
            },
            //新增
            add(){

                this.title='新增'
                this.editData={
                    nfc:"",
                    no:"",
                    type:'',
                    name:"",
                    dcsNo:"",
                    position:"",
                    calculationFormula:"",
                    inspectionPeriod:'',
                    inspectionTime:"",
                    buyTime:"",
                    regisTime:"",
                    guaranteeTime:"",
                    moneyBuy:"",
                    personLiableId:'',
                    orderNo:1,
                    description:"",
                    // isNfc:1,
                    isDcs:1,


                    id:0,
                    lruid:parseFloat(sessionStorage.getItem("userid")) ,
                    vc_lruname:sessionStorage.getItem('lruname'),
                    state:1

                }
                this.bianjipingtai=true
            },
            //编辑
            addson(e){
                this.title='新增DCS配置'
                this.listid=e.id
              this.editData={
                  id:0,
                  orderNo:1,
                  dcsWidth
                      :
                      "",

                  inputTitle
                      :
                      "",
                  inputType
                      :
                      "",
                  inputUnit
                      :
                      "",
                  inputWidth
                      :
                      "",
                  lowerBound
                      :
                      "",
                  name
                      :
                      "",
                  no
                      :
                      "",
                  pid
                      :
                      e.id,
                  upperBound
                      :
                      "",
                  lruid:parseFloat(sessionStorage.getItem("userid")) ,
                  vc_lruname:sessionStorage.getItem('lruname'),

              }
              this.sondialog=true
            },
            //aaaa
            async list(val) {

                //console.log(val)
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    pid:this.listid
                    // isNext:this.editData.isNext
                }
                // console.log(params)
                // return
                let res = await API.list(params);
                if (res.code == 1) {

                    this.tableData.forEach(item=>{
                        if(item.id==this.listid){
                            this.$set(item,'erbei',res.data)

                        }
                    })
                    // console.log(this.listid)
                    // console.log(this.tableData)
                    // this.childrenlist=res.data

                } else if (res.code == -2) {
                    // this.loading.loading=false

                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    // this.loading.loading=false

                    this.$message.error(res.message);
                }
            },
            edit(val){
                // console.log(val)
                this.title='编辑设备'
                // console.log(val)
                this.editData.id=val.id
                this.editData=Object.assign({},val);
// this.dcsdetail()
                this.bianjipingtai=true
                // this.getServiceConfigDetail()

                // console.log(this.editData)
            },
            editson(e){
                this.title='编辑DCS'
                this.listid=e.pid
                // console.log(e)
                // this.editData.pid=e.id
                this.editData=Object.assign({},e);
// this.dcsdetail()
                this.sondialog=true
            },
            //确认作废
            submitdel(){
                this.dcscancel()
                this.clist()
                // console.log(this.editData)
                this.delDialogVisible=false
            },
            //作废
            submitsondel(){
                this.dcsdelete()
                this.delsonDialogVisible=false

            },
            delson(val){
                this.title='删除'
                this.editData=val
                this.listid=val.pid
                // this.templateUsed()
                this.deldetail='是否要删除'

                this.delsonDialogVisible=true
            },
            del(val){
                this.title='删除'
                this.editData=val
                // this.templateUsed()
                this.deldetail='是否要删除'

                this.delDialogVisible=true

                // console.log(this.editData)
                // console.log(this.editData.id)
            },

            //业务配置列表查询
            async dcslist() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    search:this.Searchdata,
                    currentPage: this.currentPage,
                    pageSize: this.pageSize
                }
                let res = await API.dcslist(params);
                //console.log(res)
                if (res.code == 1) {
                    // console.log(this.listid)
                    this.tableData=res.data.list
                    this.total=res.data.total
                    // this.$nextTick(()=>{
                        this.tableData.forEach(item=>{
                            item.createTime=item.createTime.substring(0,10)
                            // console.log(this.$refs.deliverlight.toggleRowExpansion(item,false))
                        })

                    // document.getElementsByClassName('.el-icon-arrow-right').
                    // this.$forceUpdate()
                    // })
                    //

                    // console.log(this.tableData)
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            load(tree,treeNode,resolve){
                // this.loading=i
                this.maps.set(tree.id, {tree, treeNode, resolve});

                // console.log(i,q)
                // setTimeout(()=>{
                //     resolve(
                //         this.childrenlist
                //     )
                // },1000)
            },

dddd(e,i){
    const isExpend = i.some(r => r.id === e.id) // 判断当前行展开状
    if (isExpend) {
        this.listid=e.id
        this.list()
        // this.tableData.forEach(item=>{
            // if(this.listid!==item.id){
                // this.$refs.deliverlight.toggleRowExpansion(item,false)
                // console.log(this.$refs.deliverlight.toggleRowExpansion(item,false))

            // }
        // })
        // console.log(e,i)

        // Do some things
    } else {
        return
    }

},
            //作废验证
            async dcscancel() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    id:this.editData.id,
                    state:-1
                }
                let res = await API.dcscancel(params);
                if (res.code == 1) {
                    this.dcslist()
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    // this.deldetail='是否要删除'
                    // console.log(res)
                } else if (res.code == -2) {

                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    // console.log(res)
                    // this.deldetail=res.message

                    this.$message.error(res.message);
                }
            },
            async dcsdelete() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    id:this.i.id,

                }
                let res = await API.dcsdelete(params);
                if (res.code == 1) {
                    this.list()
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    // this.deldetail='是否要删除'
                    // console.log(res)
                } else if (res.code == -2) {

                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    // console.log(res)
                    // this.deldetail=res.message

                    this.$message.error(res.message);
                }
            },



        },

    }
</script>
<style lang="scss" scoped>
    .flexcenter{
        min-width: 39.286rem;
        width: 100%;
        height: 2.857rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 0.857rem;
    }
    /deep/.el-table__expanded-cell{
        padding: 5px 0px;
    }
    /deep/{
        .el-table--enable-row-transition{
            /*min-width: 53.571rem !important;*/
        }
        .el-button--text{
            padding: 0 !important;
            margin-left: 0 !important;
            margin-right: 10px;
        }
        .el-tabs__content{
            /*height: 90% !important;*/
            overflow: visible !important;
            height:calc(100% - 0.357rem) !important;
        }
    }
    /deep/.is-leaf .cell .el-checkbox__input{
        display: none;
    }
    .m{
        padding-top: 1.429rem;
    }
    .flexother {
        display: flex;
        /*flex-flow: wrap;*/
        justify-content: space-between;
        align-items: center;
    }
    .fl{
        float: left;
        .el-button--primary{
            color: #efd773;
            background-color:white;
            border: 0;
            text-align: center;
            padding: 0;
            height: 2rem;
            width: 3.286rem;
            margin:0.857rem 0 0 0.714rem;
        }
    }

    .fr{
        float:right;
    }

    .cl{
        clear: both;
    }
    .input{
        width: 14.286rem;
    }
    /*.mrt20{*/
    /*    margin-top: 1.429rem;*/
    /*}*/
    .mrl20{
        margin-left: 1.429rem;
    }
    .mrb20{
        margin-right: 1.429rem;
    }
    .mrr20{
        margin-right: 1.429rem;
    }

    .chooseheader{
        width:100%;
    }

    .choosepage{
        /*min-width: 42.571rem;*/
        width:90%
    }
    /deep/.el-table__header{
        width: 100% !important;
    }
    /deep/.el-table__body{
        width: 100% !important;

    }
    .left{
        width: 17.857rem;
    }
</style>